"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationList = void 0;
var _mui = require("@ori-ui/mui");
var _useIsDesktop = require("../../hooks/useIsDesktop");
var _upperCaseFirst = require("../../utils/upperCaseFirst");
var _FormattedMessage = require("../FormattedMessage");
var _LoadingPlaceholder = require("../LoadingPlaceholder");
var _NotificationListItem = require("./NotificationListItem");
var _jsxRuntime = require("react/jsx-runtime");
const EmptyNotificationsList = (0, _mui.styled)(_mui.ListItem)(({
  theme
}) => ({
  color: theme.palette.grey.A400,
  backgroundColor: theme.palette.common.white,
  justifyContent: 'center',
  zIndex: -1,
  width: '100vw',
  height: 'calc(100vh - var(--top-nav-height) - 3.125rem)',
  [theme.breakpoints.up('sm')]: {
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(18),
    width: theme.spacing(80),
    height: 'auto'
  }
}));
const NotificationListItem = (0, _mui.styled)(_mui.ListItem)(() => ({
  padding: 0
}));
const NotificationListLayout = (0, _mui.styled)(_mui.List)(() => ({
  width: '100%',
  padding: 0
}));
const NotificationTitle = (0, _mui.styled)(_mui.ListSubheader)(({
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  top: -1,
  marginBottom: 10
}));
const NotificationList = ({
  notificationsData,
  handleDelete,
  handleMarkAsViewed
}) => {
  const isDesktop = (0, _useIsDesktop.useIsDesktop)();
  const isLoading = !notificationsData;
  const nonEmptySections = Object.entries(notificationsData?.notifications ?? []).filter(([_, sectionNotifications]) => sectionNotifications.length > 0);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(EmptyNotificationsList, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingPlaceholder.Loading, {})
    }) : null, nonEmptySections.length === 0 && !isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(EmptyNotificationsList, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: isDesktop ? 'h6' : 'h5',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "NoNewNotifications"
        })
      })
    }), nonEmptySections.map(([sectionKey, sectionNotifications]) => /*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationListItem, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(NotificationListLayout, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(NotificationTitle, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: (0, _upperCaseFirst.upperCaseFirst)(sectionKey)
          })
        }), sectionNotifications.map((notificationItem, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotificationListItem.NotificationsListItem, {
          notification: notificationItem,
          handleDelete: handleDelete,
          handleMarkAsViewed: handleMarkAsViewed,
          index: index,
          section: sectionKey
        }, notificationItem.notificationId))]
      })
    }, `section-${sectionKey}`))]
  });
};
exports.NotificationList = NotificationList;
